import { Injectable, NgZone } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { grpc } from '@improbable-eng/grpc-web';

import {
  DeleteBellScheduleRequest,
  DeleteBellScheduleResponse,
  GetBellScheduleRequest,
  GetBellScheduleResponse,
  GetBellSchedulesRequest,
  GetBellSchedulesResponse,
  OverrideBellScheduleForDateRequest,
  OverrideBellScheduleForDateResponse,
  UpsertBellScheduleRequest,
  UpsertBellScheduleResponse,
} from '../bell_schedule/bell_schedule_pb';

import {
  BellScheduleManager as __BellScheduleManager,
} from '../bell_schedule/bell_schedule_pb_service';

@Injectable({providedIn: 'root'})
export class BellScheduleManager {

  constructor(private _ngZone: NgZone) {
  }

  getBellSchedule(request: GetBellScheduleRequest): Promise<GetBellScheduleResponse>;
  getBellSchedule(request: GetBellScheduleRequest, metadata: grpc.Metadata): Promise<GetBellScheduleResponse>;
  getBellSchedule(request: GetBellScheduleRequest, callback: (err: any|null, response: GetBellScheduleResponse, metadata: grpc.Metadata) => void): void;
  getBellSchedule(request: GetBellScheduleRequest, metadata: grpc.Metadata, callback: (err: any|null, response: GetBellScheduleResponse, metadata: grpc.Metadata) => void): void;

  getBellSchedule(request: GetBellScheduleRequest, arg1?: grpc.Metadata|((err: any|null, response: GetBellScheduleResponse, metadata: grpc.Metadata) => void), arg2?: (err: any|null, response: GetBellScheduleResponse, metadata: grpc.Metadata) => void): Promise<GetBellScheduleResponse>|void {
    let ret: any;
    let callback: any;
    let metadata: any;

    if(typeof arg1 === 'function') {
      callback = arg1;
    } else {
      metadata = arg1;
      callback = arg2;
    }

    if(!callback) {
      ret = new Promise<GetBellScheduleResponse>((resolve, reject) => {
        callback = (err: any, response: any) => {
          if(err) reject(err);
          else resolve(response);
        };
      });
    }

    let responseMetadata: grpc.Metadata|null = null;

    let req = grpc.invoke(__BellScheduleManager.GetBellSchedule, {
      request: request,
      host: (<any>window).DEFAULT_ANGULAR_GRPC_HOST || 'https://' + location.hostname,
      metadata: metadata,
      onHeaders: headers => responseMetadata = headers,
      onMessage: response => this._ngZone.run(() => {
        callback(null, response, responseMetadata || new grpc.Metadata());
      }),
      onEnd: (code, msg, metadata) => this._ngZone.run(() => {
        if(code != grpc.Code.OK) {
          let err = new Error(msg);
          (<any>err).code = code;
          callback(err);
        }
      })
    });

    (<any>ret).cancel = () => req.close();
    return ret;
  }

  getBellSchedules(request: GetBellSchedulesRequest): Promise<GetBellSchedulesResponse>;
  getBellSchedules(request: GetBellSchedulesRequest, metadata: grpc.Metadata): Promise<GetBellSchedulesResponse>;
  getBellSchedules(request: GetBellSchedulesRequest, callback: (err: any|null, response: GetBellSchedulesResponse, metadata: grpc.Metadata) => void): void;
  getBellSchedules(request: GetBellSchedulesRequest, metadata: grpc.Metadata, callback: (err: any|null, response: GetBellSchedulesResponse, metadata: grpc.Metadata) => void): void;

  getBellSchedules(request: GetBellSchedulesRequest, arg1?: grpc.Metadata|((err: any|null, response: GetBellSchedulesResponse, metadata: grpc.Metadata) => void), arg2?: (err: any|null, response: GetBellSchedulesResponse, metadata: grpc.Metadata) => void): Promise<GetBellSchedulesResponse>|void {
    let ret: any;
    let callback: any;
    let metadata: any;

    if(typeof arg1 === 'function') {
      callback = arg1;
    } else {
      metadata = arg1;
      callback = arg2;
    }

    if(!callback) {
      ret = new Promise<GetBellSchedulesResponse>((resolve, reject) => {
        callback = (err: any, response: any) => {
          if(err) reject(err);
          else resolve(response);
        };
      });
    }

    let responseMetadata: grpc.Metadata|null = null;

    let req = grpc.invoke(__BellScheduleManager.GetBellSchedules, {
      request: request,
      host: (<any>window).DEFAULT_ANGULAR_GRPC_HOST || 'https://' + location.hostname,
      metadata: metadata,
      onHeaders: headers => responseMetadata = headers,
      onMessage: response => this._ngZone.run(() => {
        callback(null, response, responseMetadata || new grpc.Metadata());
      }),
      onEnd: (code, msg, metadata) => this._ngZone.run(() => {
        if(code != grpc.Code.OK) {
          let err = new Error(msg);
          (<any>err).code = code;
          callback(err);
        }
      })
    });

    (<any>ret).cancel = () => req.close();
    return ret;
  }

  upsertBellSchedule(request: UpsertBellScheduleRequest): Promise<UpsertBellScheduleResponse>;
  upsertBellSchedule(request: UpsertBellScheduleRequest, metadata: grpc.Metadata): Promise<UpsertBellScheduleResponse>;
  upsertBellSchedule(request: UpsertBellScheduleRequest, callback: (err: any|null, response: UpsertBellScheduleResponse, metadata: grpc.Metadata) => void): void;
  upsertBellSchedule(request: UpsertBellScheduleRequest, metadata: grpc.Metadata, callback: (err: any|null, response: UpsertBellScheduleResponse, metadata: grpc.Metadata) => void): void;

  upsertBellSchedule(request: UpsertBellScheduleRequest, arg1?: grpc.Metadata|((err: any|null, response: UpsertBellScheduleResponse, metadata: grpc.Metadata) => void), arg2?: (err: any|null, response: UpsertBellScheduleResponse, metadata: grpc.Metadata) => void): Promise<UpsertBellScheduleResponse>|void {
    let ret: any;
    let callback: any;
    let metadata: any;

    if(typeof arg1 === 'function') {
      callback = arg1;
    } else {
      metadata = arg1;
      callback = arg2;
    }

    if(!callback) {
      ret = new Promise<UpsertBellScheduleResponse>((resolve, reject) => {
        callback = (err: any, response: any) => {
          if(err) reject(err);
          else resolve(response);
        };
      });
    }

    let responseMetadata: grpc.Metadata|null = null;

    let req = grpc.invoke(__BellScheduleManager.UpsertBellSchedule, {
      request: request,
      host: (<any>window).DEFAULT_ANGULAR_GRPC_HOST || 'https://' + location.hostname,
      metadata: metadata,
      onHeaders: headers => responseMetadata = headers,
      onMessage: response => this._ngZone.run(() => {
        callback(null, response, responseMetadata || new grpc.Metadata());
      }),
      onEnd: (code, msg, metadata) => this._ngZone.run(() => {
        if(code != grpc.Code.OK) {
          let err = new Error(msg);
          (<any>err).code = code;
          callback(err);
        }
      })
    });

    (<any>ret).cancel = () => req.close();
    return ret;
  }

  deleteBellSchedule(request: DeleteBellScheduleRequest): Promise<DeleteBellScheduleResponse>;
  deleteBellSchedule(request: DeleteBellScheduleRequest, metadata: grpc.Metadata): Promise<DeleteBellScheduleResponse>;
  deleteBellSchedule(request: DeleteBellScheduleRequest, callback: (err: any|null, response: DeleteBellScheduleResponse, metadata: grpc.Metadata) => void): void;
  deleteBellSchedule(request: DeleteBellScheduleRequest, metadata: grpc.Metadata, callback: (err: any|null, response: DeleteBellScheduleResponse, metadata: grpc.Metadata) => void): void;

  deleteBellSchedule(request: DeleteBellScheduleRequest, arg1?: grpc.Metadata|((err: any|null, response: DeleteBellScheduleResponse, metadata: grpc.Metadata) => void), arg2?: (err: any|null, response: DeleteBellScheduleResponse, metadata: grpc.Metadata) => void): Promise<DeleteBellScheduleResponse>|void {
    let ret: any;
    let callback: any;
    let metadata: any;

    if(typeof arg1 === 'function') {
      callback = arg1;
    } else {
      metadata = arg1;
      callback = arg2;
    }

    if(!callback) {
      ret = new Promise<DeleteBellScheduleResponse>((resolve, reject) => {
        callback = (err: any, response: any) => {
          if(err) reject(err);
          else resolve(response);
        };
      });
    }

    let responseMetadata: grpc.Metadata|null = null;

    let req = grpc.invoke(__BellScheduleManager.DeleteBellSchedule, {
      request: request,
      host: (<any>window).DEFAULT_ANGULAR_GRPC_HOST || 'https://' + location.hostname,
      metadata: metadata,
      onHeaders: headers => responseMetadata = headers,
      onMessage: response => this._ngZone.run(() => {
        callback(null, response, responseMetadata || new grpc.Metadata());
      }),
      onEnd: (code, msg, metadata) => this._ngZone.run(() => {
        if(code != grpc.Code.OK) {
          let err = new Error(msg);
          (<any>err).code = code;
          callback(err);
        }
      })
    });

    (<any>ret).cancel = () => req.close();
    return ret;
  }

  overrideBellScheduleForDate(request: OverrideBellScheduleForDateRequest): Promise<OverrideBellScheduleForDateResponse>;
  overrideBellScheduleForDate(request: OverrideBellScheduleForDateRequest, metadata: grpc.Metadata): Promise<OverrideBellScheduleForDateResponse>;
  overrideBellScheduleForDate(request: OverrideBellScheduleForDateRequest, callback: (err: any|null, response: OverrideBellScheduleForDateResponse, metadata: grpc.Metadata) => void): void;
  overrideBellScheduleForDate(request: OverrideBellScheduleForDateRequest, metadata: grpc.Metadata, callback: (err: any|null, response: OverrideBellScheduleForDateResponse, metadata: grpc.Metadata) => void): void;

  overrideBellScheduleForDate(request: OverrideBellScheduleForDateRequest, arg1?: grpc.Metadata|((err: any|null, response: OverrideBellScheduleForDateResponse, metadata: grpc.Metadata) => void), arg2?: (err: any|null, response: OverrideBellScheduleForDateResponse, metadata: grpc.Metadata) => void): Promise<OverrideBellScheduleForDateResponse>|void {
    let ret: any;
    let callback: any;
    let metadata: any;

    if(typeof arg1 === 'function') {
      callback = arg1;
    } else {
      metadata = arg1;
      callback = arg2;
    }

    if(!callback) {
      ret = new Promise<OverrideBellScheduleForDateResponse>((resolve, reject) => {
        callback = (err: any, response: any) => {
          if(err) reject(err);
          else resolve(response);
        };
      });
    }

    let responseMetadata: grpc.Metadata|null = null;

    let req = grpc.invoke(__BellScheduleManager.OverrideBellScheduleForDate, {
      request: request,
      host: (<any>window).DEFAULT_ANGULAR_GRPC_HOST || 'https://' + location.hostname,
      metadata: metadata,
      onHeaders: headers => responseMetadata = headers,
      onMessage: response => this._ngZone.run(() => {
        callback(null, response, responseMetadata || new grpc.Metadata());
      }),
      onEnd: (code, msg, metadata) => this._ngZone.run(() => {
        if(code != grpc.Code.OK) {
          let err = new Error(msg);
          (<any>err).code = code;
          callback(err);
        }
      })
    });

    (<any>ret).cancel = () => req.close();
    return ret;
  }

}

